export class Cast {
	static array(what, classInstance) {
		const tmp = [];
		for (let i in what) {
			let insured = new classInstance();
			Object.assign(insured, what[i]);
			tmp.push(insured);
		}

		return tmp;
	}


	static instance(what, classInstance) {
		const insured = new classInstance();
		Object.assign(insured, what);
		return insured;
	}
}
